import React, { useEffect, useRef, useState } from 'react'
import { isEmpty } from 'lodash-es'

import { TtButton, TtCard, TtIcon } from '@23/ui-react'

import {
  injectScriptInNode,
  injectLinkInNode,
} from '../../../../../../../sharedLegacy/utils'
import { type WidgetDTO } from '../../../../../../model/Widget'
import { useVideoPreviewSettingsContext } from '../../../../VideoPreviewSettingsContext'

interface CalendlyPreviewProps {
  widget: WidgetDTO
  isEditable: boolean
  handleEdit: () => void
  handleDelete: () => void
}

const CalendlyPreview = ({
  widget,
  isEditable,
  handleEdit,
  handleDelete,
}: CalendlyPreviewProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [showActions, setShowActions] = useState(false)
  const { scrubberColor } = useVideoPreviewSettingsContext()

  useEffect(() => {
    if (!wrapperRef.current) return
    if (!isEmpty(widget.script_url)) {
      injectScriptInNode(wrapperRef.current, widget.script_url)
    }
    if (!isEmpty(widget.style_url)) {
      injectLinkInNode(wrapperRef.current, widget.style_url)
    }
  }, [widget.script_url, widget.style_url])

  if (!widget.embed_html) return null

  return (
    <div
      className="personal-widget-calendly-wrapper"
      onMouseEnter={() => isEditable && setShowActions(true)}
      onFocus={() => isEditable && setShowActions(true)}
      onMouseLeave={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      onBlur={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isEditable ? 0 : undefined}
    >
      <TtCard
        className="personal-widget-calendly"
        hideLabel
        style={{ '--widget-brand-color': scrubberColor } as React.CSSProperties}
      >
        {isEditable && showActions && (
          <div className="personal-widget-calendly-actions">
            <TtButton
              color="secondary"
              variant="light"
              size="x-small"
              className="personal-widget-calendly-action personal-widget-calendly-action--delete"
              onClick={handleDelete}
              label="Delete"
            >
              <TtIcon library="one" name="bin" />
            </TtButton>
            <TtButton
              color="secondary"
              variant="light"
              size="x-small"
              className="personal-widget-calendly-action personal-widget-calendly-action--edit"
              onClick={handleEdit}
              label="Edit"
            >
              <TtIcon library="one" name="edit" />
            </TtButton>
          </div>
        )}
        <div ref={wrapperRef} className="personal-widget-calendly-inner">
          <div
            className="personal-widget-calendly-content"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: widget.embed_html }}
          />
        </div>
      </TtCard>
    </div>
  )
}

export { CalendlyPreview }
